import { FlowRevision } from '../types/FlowRevision';
import { IGetItemsParams } from '../../../ts/ServerApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../../ts/ServerApi/types/IGetItemsResult';
import { Request } from '../../../ts/ServerApi/requests/Request';

export interface GetFlowVersionsParams extends IGetItemsParams {
}

export interface GetFlowVersionsResult extends IGetItemsResult {
  versions: FlowRevision[];
}

export class GetFlowVersionsRequest extends Request<GetFlowVersionsParams, GetFlowVersionsResult> {
  constructor(params: GetFlowVersionsParams) {
    super('getFlowVersions', params);
  }
}
